<template>
  <div id="app">
    <biotech-header v-if="!isPrintView && !$store.getters.planansichtApp && this.$route.name != 'Auth'" />
    <main class=".routerView container-fluid">
      <transition name="fade" mode="out-in">
        <router-view />
      </transition>
    </main>
    <biotech-footer v-if="(!isPrintView || !hideFooter) && !$store.getters.planansichtApp && this.$route.name != 'Auth'"  />
    <spinner />

    <!-- Re-Login Modal bei abgelaufener Session (nicht in der externen Planansicht, z.B. via externalAuthBootstrap) -->
    <b-modal id="modal-session-expired"
             :visible="$store.getters.sessionExpired && !$store.getters.planansichtApp"
             :title="$t('message.session_abgelaufen_titel')"
             no-close-on-backdrop
             no-close-on-esc
             hide-header-close
             hide-footer
             centered>

      <b-alert variant="warning" show>
        {{ $t('message.session_abgelaufen_text') }}
      </b-alert>
      <form @submit.prevent="doReLogin">
        <div class="form-group">
          <label for="relogin-username">{{ $t('message.login_username') }}</label>
          <input type="text"
                 class="form-control"
                 id="relogin-username"
                 required
                 v-model="reLoginUsername" />
        </div>
        <div class="form-group">
          <label for="relogin-password">{{ $t('message.login_password') }}</label>
          <input type="password"
                 class="form-control"
                 id="relogin-password"
                 required
                 v-model="reLoginPassword" />
        </div>
        <b-alert variant="danger" :show="reLoginError" class="mt-2">
          {{ $t('message.login_error') }}
        </b-alert>
        <b-button type="submit" variant="primary" :disabled="!reLoginUsername || !reLoginPassword" class="mt-2">
          <span class="oi oi-account-login"></span>&nbsp;{{ $t('message.login') }}
        </b-button>
      </form>

    </b-modal>

  </div>
</template>

<script>

  import BiotechHeader from './components/layout/BiotechHeader.vue';
  import BiotechFooter from './components/layout/BiotechFooter.vue'
  import Spinner from './components/layout/Spinner.vue';
  import axios from 'axios';

  export default {
    name: 'app',
    components: {
      BiotechHeader,
      BiotechFooter,
      Spinner
    },
    data () {
      return {
        reLoginUsername: null,
        reLoginPassword: null,
        reLoginError: false
      }
    },
    methods: {

      doReLogin: function () {
        var that = this
        this.reLoginError = false
        var url = process.env.VUE_APP_SERVER_URL + '/login/auth'
        axios({
          method: 'POST',
          data: {
            username: this.reLoginUsername,
            password: this.reLoginPassword,
            lang: this.$i18n.locale
          },
          url: url
        }).then(function (response) {
          if (response.data.error) {
            that.reLoginError = true
          } else {
            that.$store.commit('setUserRole', response.data.role)
            that.$store.commit('setUser', response.data.user)
            that.$store.commit('setSessionExpired', false)
            that.reLoginUsername = null
            that.reLoginPassword = null
            that.reLoginError = false
          }
        }).catch(function () {
          that.reLoginError = true
        })
      }

    },
    computed: {

      /**
       * keinen Header und keinen Footer bei Druckansicht
       * @returns {boolean}
       */
      isPrintView: function () {

        var name = this.$route.name ? this.$route.name : this.$route.path;
        if (name == 'PrintErgebnisliste' || name == 'PrintMaengel') {
          return true;
        }
        return false;

      },
      /**
       * Footer ausblenden bei bestimmten Seiten
       * @returns {boolean}
       */
      hideFooter: function () {

        var name = this.$route.name ? this.$route.name : this.$route.path;
        if (name == 'Plan') {
          return true;
        }
        return false;

      }

    },
    created () {

      // merke dir den deep Link und die Parameter, um nach dem Login dorthin zurück zu routen
      console.log('route query: ' + this.$route.query)
      console.log('route name: '  + this.$route.name)
      this.$store.commit('setRouteQuery', this.$route.query)
      this.$store.commit('setRouteName',  this.$route.name)

      const name = this.$route.name ? this.$route.name : this.$route.path

      // wenn nicht eingeloggt, dann darf nur Welcome, ForgotPassword, NewPassword oder Login geöffnet sein
      if (!this.$store.getters.user) {
        console.log('niemand ist eingeloggt in ' + name)
        if (
                name != 'Welcome' &&
                name != 'ForgotPassword' &&
                name != 'NewPassword' &&
                name != 'Login' &&
                name != 'PrintErgebnisliste' &&
                name != 'PrintPositionen' &&
                name != 'PrintMaengel' &&
                name != 'ApiDoc' &&
                !this.$store.getters.planansichtApp &&
                name != 'Auth' &&
                name != 'ExternalPlanAuth'
        ) {
          this.$router.push('/')
        }
      }

    }

  }

</script>
